<template>
  <b-table 
    :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
    @row-clicked="rowClicked"
    :items="items" 
    :fields="tableFields"
    thead-class="d-none"
    primary-key="id" 
    :tbody-tr-class="rowClass" 
  >
    <template #cell(date)="data">
        <span class="transaction-date">{{ data.value | formatDate }}</span>
    </template>

    <template #cell(description)="data">
        <span v-b-tooltip.hover :title="data.value" class="transaction-description">{{ data.value }}</span>
    </template>

    <template #cell(amount)="data">
        <div class="text-right">€ {{ data.value | formatNumber }}</div>
    </template>
    <template #cell(actions)="row">
        <div class="text-right">
          <GekkoButton 
            @click="editItem(row.item)"
            icon="fa-solid fa-pen-to-square"
            class="text-primary"
            size="sm"
            variant="link"
            v-b-tooltip.hover :title="$gettext('Edit this item')"
          />
          <GekkoButton 
            @click="disconnectFromTransaction(row.item)"
            icon="fa-solid fa-link-slash"
            class="text-danger"
            size="sm"
            variant="link"
            v-b-tooltip.hover :title="$gettext('Disconnect this item')"
          />
        </div>
    </template>
  </b-table>
</template>

<script>
import GekkoButton from "@/components/GekkoButton"
export default {
  name: "BankMatchedCostTable",
  components: {
    GekkoButton,
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      tableFields: [
        { key: 'date', tdClass: 'col-date width-125' },
        { key: 'description', tdClass: 'col-description d-none d-md-table-cell ellipsis' },
        { key: 'amount', tdClass: 'col-amount' },
        { key: 'actions' }
      ]
    }
  },
  created () {
  },
  methods: {
    rowClicked (item) {
      this.$emit('row-clicked', item);
    },
    rowClass (item) {
      if(item && item.type) return 'transaction-row-' + item.type
    },
    disconnectFromTransaction (item) {
      this.$emit('disconnect-item', { item: item, type: 'cost' });
    },
    editItem (item) {
      this.$emit('edit-item', item);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
